import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	sendError: {
		id: 'sendDialogToEmail.sendError',
		defaultMessage: 'Отправка истории диалога на почту временно недоступна. Попробуйте позже.',
	},
	incorrectEmail: {
		id: 'sendDialogToEmail.incorrectEmail',
		defaultMessage: 'Некорректный email',
	},
	enterYourMail: {
		id: 'sendDialogToEmail.enterYourMail',
		defaultMessage: 'Введите вашу почту',
	},
	sendDialogToEmail: {
		id: 'sendDialogToEmail.sendDialogToEmail',
		defaultMessage: 'Отправить диалог на почту',
	},
	cancel: {
		id: 'sendDialogToEmail.cancel',
		defaultMessage: 'Отмена',
	},
	dialogSent: {
		id: 'sendDialogToEmail.dialogSent',
		defaultMessage: 'Диалог отправлен на почту!',
	},
	goBack: {
		id: 'sendDialogToEmail.goBack',
		defaultMessage: 'Назад',
	},
});
